import { render, staticRenderFns } from "./ipProfiles.vue?vue&type=template&id=151e4adf"
import script from "./ipProfiles.vue?vue&type=script&lang=js"
export * from "./ipProfiles.vue?vue&type=script&lang=js"
import style0 from "./ipProfiles.vue?vue&type=style&index=0&id=151e4adf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports